<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-title">FOREWORD</p>
<p class="noindent">Jan Johnson has previously taken us on fascinating tours of Galveston Island, first “walking us” through its hallowed neighborhoods and then “driving us” to even further adventures across the entire Island. We learned who lived where and when (and who was buried where and when!), along with just how Galveston grew from a dangerous outpost to a bustling port to a polished jewel of a city. Behind all those Victorian homes, German churches and Wall Street–designed businesses, the men and women who staked their very souls and fortunes on the success and future of the Island stood their ground fearlessly. <i>Unforgettable Galveston Characters</i> beautifully introduces us to those Island pioneers (for better, for worse and those in between) who got here long before we did. From the businessmen to the bootleggers and musicians, the matrons and the myths, the bit players and the soaring stars who found international fame, Jan’s book captures the personalities and determination of the men and women who ultimately set the tone and tenure of Galveston. Who knew that all those iron gates were placed there by such surviving spirits of steel?</p>
<p class="indent">Many Galvestonians proudly call themselves BOI, “Born on the Island.” The “Unforgettable Characters” you’ll meet in this book quite literally earned the original title of BOI—they “Built Our Island.” They deserve to be known, honored and remembered, and Jan’s words joyously do just that.</p>
<p class="right">—F<span class="small">RANK</span> B<span class="small">ILLINGSLEY</span>,<br/>Chief Meteorologist, KPRC Channel 2 News, Houston, Texas</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword.vue?ee5cfcb6